import React, { useEffect, useRef, useState } from "react";
import Masonry from "react-responsive-masonry";
import AnimatedText from "./AnimatedText";
import ImageLoader from "../chef/ImageLoader";
import { bottomBarActions } from "../../store/bottomBarSlice";
import { useDispatch } from "react-redux";

const SearchResultContainer = ({ result, loading }) => {
  const divRef = useRef(null);
  const [width, setWidth] = useState(0);
  const [showMasonry, setShowMasonry] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    const observer = new ResizeObserver((entries) => {
      for (let entry of entries) {
        window.requestAnimationFrame(() => {
          const newWidth = entry.contentRect.width;
          if (Math.abs(newWidth - width) > 1) {
            setWidth(newWidth);
          }
        });
      }
    });

    if (divRef.current) {
      observer.observe(divRef.current);
    }

    return () => {
      if (divRef.current) {
        observer.unobserve(divRef.current);
      }
    };
  }, [width]);

  const elementWidth = (width - 36) / 2;
  const height = Math.random() < 0.5 ? elementWidth : elementWidth * 1.5;

  const RESULT_ARRAY = [
    {
      img: "https://cuirato-images.s3.ap-south-1.amazonaws.com/menu/thumbnail/Veg%20aglio%20olio%20pasta.jpg",
      title: "Hyderabadi Chicken Biryani",
    },
    {
      img: "https://cuirato-images.s3.ap-south-1.amazonaws.com/menu/thumbnail/Cream%20of%20tomato%20soup.jpg",
      title: "Lucknowi (Awadhi) Chicken Biryani",
    },
    {
      img: "https://cuirato-images.s3.ap-south-1.amazonaws.com/menu/thumbnail/Ricotta%20cheese%20and%20spinach%20dumplings.jpg",
      title: "Hyderabadi Veg Biryani",
    },
    {
      img: "https://cuirato-images.s3.ap-south-1.amazonaws.com/menu/thumbnail/Veg%20club%20sandwich.jpg",
      title: "Paneer Makhni Biryani",
    },
    {
      img: "https://cuirato-images.s3.ap-south-1.amazonaws.com/menu/thumbnail/Mix%20veg%20flatbread.jpg",
      title: "Mushroom Biryani",
    },
    {
      img: "https://cuirato-images.s3.ap-south-1.amazonaws.com/menu/thumbnail/Masala%20omellete.jpg",
      title: "Prawn Biryani",
    },
    {
      img: "https://cuirato-images.s3.ap-south-1.amazonaws.com/menu/thumbnail/Malai%20paneer%20tikka.jpg",
      title: "Egg Biryani",
    },
    {
      img: "https://cuirato-images.s3.ap-south-1.amazonaws.com/menu/thumbnail/Chatpata%20paneer%20kathi%20roll.jpg",
      title: "Vegetable Biryani",
    },
    {
      img: "https://cuirato-images.s3.ap-south-1.amazonaws.com/menu/thumbnail/tandoori%20roti.jpg",
      title: "Fish Biryani",
    },
    {
      img: "https://cuirato-images.s3.ap-south-1.amazonaws.com/menu/thumbnail/chicken%20manchow%20soup.jpg",
      title: "Mutton Biryani",
    },
  ];

  
  const texts = [
    {
      content: "Search is in demo mode.",
      className: "searchResultHeader Satoshi mast__text",
    },
    {
      content:
        "We’re building a deep search that understands your taste. Soon, you’ll be able to find dishes or a customised list of dishes that perfectly match your preferences and what you’re searching for.",
      className: "searchResultLabelDesc Satoshi mast__text",
    },
    
  ];

  let delay = 0;
  const blockDuration = (text) => {
    const words = text.split(" ").length;
    return (words - 1) * 0.15 + 0.3;
  };

  const WORD_DELAY = 0.20; // seconds
  const ANIM_DURATION = 0.4; // seconds

  const blockDurationTotal = (text) => {
    const words = text.trim().split(/\s+/).length;
    return (words - 1) * WORD_DELAY + ANIM_DURATION;
  };

  const totalAnimationTime = texts.reduce(
    (acc, t) => acc + blockDurationTotal(t.content),
    0
  );

  const totalAnimationDuration = Math.floor(totalAnimationTime * 1000)


  useEffect(() => {
    const timer = setTimeout(() => {
      setShowMasonry(true);
    }, totalAnimationDuration); 

    return () => clearTimeout(timer);
  }, []);

  const handleSearchResultClick = () =>{
     dispatch(bottomBarActions.loadTab({ tabName: "account" }));
  }

  if (loading) {
    return <ImageLoader className="loader_wrapper" />;
  }


  return (
    <div className="searchComponentMainResultWrapper">
      {/* <AnimatedText
        text="2 Different flavoured spicy biryani for pack of 14"
        className="searchResultHeader Satoshi mast__text"
      />

      <AnimatedText
        text="For a pack serving 14, here are two different and popular biryani flavours that will please a diverse group: Hyderabadi Biryani & Lucknowi (Awadhi) Biryani."
        className="searchResultLabelDesc Satoshi mast__text"
      />

      <div style={{ marginTop: 18, marginBottom: 20 }}>
        <AnimatedText
          text="You can also explore different options from our menu as below."
          className="searchResultLabelDesc Satoshi mast__text"
          style={{ marginTop: 18, marginBottom: 20 }}
        />
      </div> */}
      {texts.map((t, idx) => {
        const comp = (
          <AnimatedText
            key={idx}
            text={t.content}
            className={t.className}
            startDelay={delay}
          />
        );
        delay += blockDuration(t.content);
        return comp;
      })}
      {showMasonry && (
        <div className="searchResultMasonryWrapper">
          <Masonry columnsCount={2} gutter="8px">
            {RESULT_ARRAY.map((item, index) => (
              <div key={index} onClick={handleSearchResultClick} className="searchResultMasonryContentWrapper">
                <div
                  className="searchResultMasonryContent"
                  style={{ height: height }}
                >
                  <img
                    src={item.img}
                    alt={`img-${index}`}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      borderRadius: 16,
                    }}
                  />
                  <div className="searchResultMasonryContentTitleWrapper">
                    <div className="searchResultMasonryContentTitle Satoshi">
                      {item.title}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Masonry>
        </div>
      )}
    </div>
  );
};

export default SearchResultContainer;
